// Public metadata for the Twitch chat commands Poppy understands
export const POPPY_CHAT_COMMAND_NAMESPACE = '!airhead';
// Twitch rejects identical bot messages sent less than 30 seconds apart, so a
// command can't usefully answer more often than that.
export const POPPY_CHAT_COMMAND_COOLDOWN_MS = 30000;
/**
 * One entry is one cooldown group: its name and aliases share a timer.
 * This catalog also feeds command parsing, chat help, the Library, and docs.
 * Room-specific reply formatting remains a backend concern.
 */
export const poppyChatCommands = [
    {
        name: 'room',
        description: 'Get the current room join link.',
        aliases: ['join'],
        cooldownMs: POPPY_CHAT_COMMAND_COOLDOWN_MS,
        readsRoomState: true,
    },
    {
        name: 'game',
        description: 'Learn about the game being played.',
        aliases: [],
        cooldownMs: POPPY_CHAT_COMMAND_COOLDOWN_MS,
        readsRoomState: true,
    },
    {
        name: 'about',
        description: 'Learn about Airhead Games and where to find its games.',
        aliases: [],
        cooldownMs: POPPY_CHAT_COMMAND_COOLDOWN_MS,
        readsRoomState: false,
    },
    {
        name: 'help',
        description: 'List the available Airhead Games chat commands.',
        aliases: ['commands'],
        cooldownMs: POPPY_CHAT_COMMAND_COOLDOWN_MS,
        readsRoomState: false,
    },
];
export const POPPY_CHAT_DEFAULT_COMMAND = 'help';
export const POPPY_CHAT_HELP_MESSAGE = `To use commands for Airhead Games, type "${POPPY_CHAT_COMMAND_NAMESPACE}" followed by one of these commands: ${poppyChatCommands
    .flatMap((command) => [command.name, ...command.aliases])
    .join(' | ')}`;
export function getPoppyChatCommandRows(includeDefault = false) {
    return poppyChatCommands.flatMap((command) => [
        command.name,
        ...command.aliases,
        ...(includeDefault && command.name === POPPY_CHAT_DEFAULT_COMMAND
            ? ['[empty]']
            : []),
    ].map((name) => ({ name, description: command.description })));
}
//# sourceMappingURL=poppyChatCommands.js.map